/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_minecraft_flow_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you finish, you'll be sent back to the game automatically.`)
};

const zh_hans1_minecraft_flow_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成后将自动返回游戏。`)
};

const zh_hant1_minecraft_flow_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成後將自動返回遊戲。`)
};

const fr_minecraft_flow_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois terminé, vous serez automatiquement renvoyé dans le jeu.`)
};

const de_minecraft_flow_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danach wirst du automatisch zurück ins Spiel geleitet.`)
};

const ja_minecraft_flow_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了すると自動的にゲームに戻ります。`)
};

const ko_minecraft_flow_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완료되면 자동으로 게임으로 돌아갑니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const minecraft_flow_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.minecraft_flow_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("minecraft_flow_desc", locale)
	if (locale === "en") return en_minecraft_flow_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_minecraft_flow_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_minecraft_flow_desc(inputs)
	if (locale === "fr") return fr_minecraft_flow_desc(inputs)
	if (locale === "de") return de_minecraft_flow_desc(inputs)
	if (locale === "ja") return ja_minecraft_flow_desc(inputs)
	return ko_minecraft_flow_desc(inputs)
};